var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.59959 3.99901C4.07375 3.95581 7.41416 2.65316 10.0004 0.333008C12.5864 2.65359 15.9269 3.95668 19.4012 4.00021C19.5332 4.78021 19.6004 5.58421 19.6004 6.40141C19.6004 12.6714 15.5924 18.0054 10.0004 19.9818C4.40839 18.0042 0.400391 12.6702 0.400391 6.40021C0.400391 5.58181 0.468791 4.78021 0.59959 3.99901ZM14.4488 8.44861C14.6674 8.22228 14.7883 7.91916 14.7856 7.60453C14.7829 7.28989 14.6567 6.98891 14.4342 6.76643C14.2117 6.54394 13.9107 6.41773 13.5961 6.415C13.2814 6.41226 12.9783 6.53322 12.752 6.75181L8.80039 10.7034L7.24879 9.15181C7.02247 8.93322 6.71935 8.81226 6.40471 8.815C6.09007 8.81773 5.7891 8.94394 5.56661 9.16642C5.34412 9.38891 5.21792 9.68989 5.21518 10.0045C5.21245 10.3192 5.3334 10.6223 5.55199 10.8486L7.95199 13.2486C8.17702 13.4736 8.48219 13.6 8.80039 13.6C9.11859 13.6 9.42376 13.4736 9.64879 13.2486L14.4488 8.44861Z",
    fill: "#118AB2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardIcon);
export default __webpack_public_path__ + "static/media/guardIcon.43bac32972bb2e3cbdac3d14f60099f4.svg";
export { ForwardRef as ReactComponent };